import { ERROR_MESSAGE, INFO_MESSAGE, RESET_MESSAGES, SUCCESS_MESSAGE, WARNING_MESSAGE } from '../reducers/flashbag';

export const addErrors = (messages) => ({ type: ERROR_MESSAGE, payload: { messages } });
export const addInfos = (messages) => ({ type: INFO_MESSAGE, payload: { messages } });
export const addSuccess = (messages) => ({ type: SUCCESS_MESSAGE, payload: { messages } });
export const addWarnings = (messages) => ({ type: WARNING_MESSAGE, payload: { messages } });
export const resetMessages = () => ({ type: RESET_MESSAGES });
